import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { IMemberList } from '@umu/umu-types';

export interface IPageInfo {
    current_page: number;
    list_total_num: number;
    total_num: number;
    size: number;
    total_page_num: number;
}
export interface IMemberListParam {
    department_id: string | number;
    size: number;
    page: number;
}
export interface IMemberListInfo {
    page_info: IPageInfo;
    list: IMemberList[];
}
export const getMemberList = (data: IMemberListParam) => {
    return fetchData(Api.GET_MEMBER_LIST, data).then((res: IListResponse<IMemberListInfo>) => {
        return res.data;
    });
};
